import React from "react";

export function PracticeLogo({ logoUrl }: { logoUrl: string }): React.JSX.Element {
  return <img alt={"Practice Logo"} style={{ marginBottom: 10, maxWidth: "100%" }} src={logoUrl} data-testid={"t-practice-information-logo"} />;
}
